export default function isPhone(value) {
  if (value?.value !== undefined && value.value) {
    return /^(\d{11})$/.test(value.value.replace(/[\s()+\-.]|ext/gi, ''));
  } else if (value?.value === undefined && value) {
    return /^(\d{11})$/.test(value.replace(/[\s()+\-.]|ext/gi, ''));
  } else return true;
}
